/** 장부 안쪽 여유 — 인쇄/뷰어에서 마지막 행이 테두리에 붙지 않게 */
const FIT_SAFETY = 0.985;

export function fitReportPapers(root) {
  if (!root) return;

  root.querySelectorAll('.paper').forEach((paper) => {
    const table = paper.querySelector(':scope > table');
    if (!table) return;

    table.style.zoom = '1';
    const style = window.getComputedStyle(paper);
    const padY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const available = (paper.clientHeight - padY) * FIT_SAFETY;
    const needed = table.getBoundingClientRect().height;

    if (available > 0 && needed > available + 2) {
      table.style.zoom = String(available / needed);
    } else {
      table.style.zoom = '';
    }
  });
}
